// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'clock-sla';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M10.063 16.083a6.906 6.906 0 1 0-6.907-6.906v.531' />
    <path d='m1.031 7.581 2.125 2.125 2.125-2.125m4.25-2.656v4.781h3.719' />
  </g>
);

export const viewBox = '0 0 18 18';
